import { TvStatus } from '@tmdb-graphql-api/schema/types';
import { differenceInMonths, isFuture, isPast } from 'date-fns';
import { type RibbonSeasonDetailsData, type RibbonTvDetailsData } from '../types.ts';

export const isSeasonRibbonWithinTimeframe = ({ airDate, episodes }: RibbonSeasonDetailsData['season']) => {
  const lastEpisode = episodes?.length ? episodes.at(-1) : undefined;

  return (
    (airDate && isFuture(new Date(airDate))) ??
    (airDate && isPast(new Date(airDate)) && lastEpisode?.airDate && isFuture(new Date(lastEpisode.airDate)))
  );
};

export const isTvRibbonWithinTimeframe = (
  status: TvStatus,
  { lastAirDate, nextEpisodeToAir }: RibbonTvDetailsData['tv'],
) => {
  switch (true) {
    case (status === TvStatus.Canceled || status === TvStatus.Ended) &&
      lastAirDate &&
      differenceInMonths(new Date(), new Date(lastAirDate)) < 6: {
      return true;
    }

    case status === TvStatus.ReturningSeries &&
      lastAirDate &&
      ((isPast(new Date(lastAirDate)) && !nextEpisodeToAir?.airDate) ||
        (differenceInMonths(new Date(), new Date(lastAirDate)) > 3 &&
          (!nextEpisodeToAir?.airDate || isFuture(new Date(nextEpisodeToAir.airDate))))): {
      return true;
    }

    default: {
      return false;
    }
  }
};
